import { maskSecret } from '../payment/merchantConstants';

export const DEFAULT_SMS_FORM = {
  providerKey: '',
  enabled: false,
  contentFields: {},
};

/** 新增時各服務商欄位預設值 */
export const SMS_PROVIDER_FIELD_DEFAULTS = {
  smsplant: {
    apiUrl: 'http://api.wftqm.com/api/sms/mtsend',
    template: 'Your verify code is {code}.',
  },
};

export function buildProviderNameMap(contentTypes) {
  const map = {};
  (contentTypes || []).forEach((item) => {
    if (item?.providerKey) {
      map[item.providerKey] = item.providerName || item.providerKey;
    }
  });
  return map;
}

export function buildFieldLabelMap(contentTypes) {
  const map = {};
  (contentTypes || []).forEach((item) => {
    if (!item?.providerKey) {
      return;
    }
    map[item.providerKey] = item.content || {};
  });
  return map;
}

export function getAvailableProviderOptions(contentTypes, existingKeys) {
  const used = new Set(existingKeys || []);
  return (contentTypes || []).filter((item) => item?.providerKey && !used.has(item.providerKey));
}

export function buildEmptyContentFields(providerKey, fieldLabels = {}) {
  const labels = fieldLabels[providerKey] || {};
  const defaults = SMS_PROVIDER_FIELD_DEFAULTS[providerKey] || {};
  return Object.fromEntries(
    Object.keys(labels).map((key) => [key, defaults[key] ?? ''])
  );
}

export function rowToSmsForm(row, fieldLabels = {}) {
  const providerKey = row?.providerKey || '';
  const labels = fieldLabels[providerKey] || {};
  const content = row?.content || {};
  const contentFields = {};
  Object.keys(labels).forEach((key) => {
    contentFields[key] = content[key] ?? '';
  });
  return {
    providerKey,
    enabled: Boolean(row?.enabled),
    contentFields,
  };
}

export function buildSmsFormFromProvider(providerKey, fieldLabels = {}, enabled = false) {
  return {
    providerKey,
    enabled,
    contentFields: buildEmptyContentFields(providerKey, fieldLabels),
  };
}

export function formToSmsPayload(form) {
  const content = {
    providerKey: form.providerKey,
    ...form.contentFields,
  };
  return {
    providerKey: form.providerKey,
    enabled: Boolean(form.enabled),
    content,
  };
}

export function isSecretSmsField(key) {
  if (!key) {
    return false;
  }
  const lower = key.toLowerCase();
  return lower.includes('secret') || lower.includes('md5') || lower === 'appkey' || lower === 'secretkey';
}

export function formatSmsFieldValue(key, value) {
  if (value == null || value === '') {
    return '—';
  }
  if (isSecretSmsField(key)) {
    return maskSecret(String(value));
  }
  return String(value);
}

export function getSmsProviderTitle(row, providerNameMap) {
  const key = row?.providerKey;
  if (!key) {
    return '—';
  }
  return providerNameMap[key] || key;
}

export function getSmsModalTitle(isEdit, providerKey, providerNameMap) {
  if (!isEdit) {
    return '新增';
  }
  const name = providerNameMap[providerKey] || providerKey || '短信';
  return `修改 ${name}`;
}

export function validateSmsForm(form, fieldLabels = {}) {
  if (!form.providerKey) {
    return '請選擇短信商名稱';
  }
  const labels = fieldLabels[form.providerKey] || {};
  for (const [key, label] of Object.entries(labels)) {
    const value = form.contentFields?.[key];
    if (value == null || String(value).trim() === '') {
      return `請填寫${label || key}`;
    }
  }
  return '';
}
